import { Box, Heading, SimpleGrid } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { ConcentrationLimitsDetailCard } from 'packages/borrowing-base/ui/InsightsViewComponents';
import { dollarNumberWithCommas } from 'packages/common-frontend/utils';

type BorrowingBaseSummaryDisplay = {
  key: string;
  label: string;
  value: number;
};

export const BorrowingBaseCalcs = ({
  borrowingBaseCalcOutputs,
  eligibilityCriteriaCalcOutputs,
  concentrationLimitCalcOutputs,
}: {
  borrowingBaseCalcOutputs: BorrowingBaseSummaryDisplay[];
  eligibilityCriteriaCalcOutputs: BorrowingBaseSummaryDisplay[];
  concentrationLimitCalcOutputs: BorrowingBaseSummaryDisplay[];
}) => {
  return (
    <Box border="1px solid white" padding="30px" mb="25px">
      {/* borrowing base calcs */}
      {borrowingBaseCalcOutputs.length > 0 && (
        <>
          <Heading as="h3" fontSize="xl" mb="30px">
            Borrowing base calculations
          </Heading>
          <Box mt="25px" mb="25px">
            <SimpleGrid
              columns={{
                sm: 1,
                md: 2,
                lg: 3,
                xl: 4,
              }}
              spacingX={8}
              spacingY={10}
              mb={30}
            >
              {_.map(
                borrowingBaseCalcOutputs,
                (BorrowingBaseSummaryDisplay) => {
                  return (
                    <ConcentrationLimitsDetailCard
                      label={BorrowingBaseSummaryDisplay.label}
                      formattedValue={dollarNumberWithCommas(
                        BorrowingBaseSummaryDisplay.value,
                      )}
                      key={BorrowingBaseSummaryDisplay.key}
                    />
                  );
                },
              )}
            </SimpleGrid>
          </Box>
        </>
      )}

      {/* eligibility criteria calcs */}
      {eligibilityCriteriaCalcOutputs.length > 0 && (
        <>
          <Heading as="h3" fontSize="xl" mb="30px">
            Eligibility criteria calculations
          </Heading>
          <Box mt="25px" mb="25px">
            <SimpleGrid
              columns={{
                sm: 1,
                md: 2,
                lg: 3,
                xl: 4,
              }}
              spacingX={8}
              spacingY={10}
              mb={30}
            >
              {_.map(
                eligibilityCriteriaCalcOutputs,
                (eligibilityCriteriaCalcOutput) => {
                  return (
                    <ConcentrationLimitsDetailCard
                      label={eligibilityCriteriaCalcOutput.label}
                      formattedValue={dollarNumberWithCommas(
                        eligibilityCriteriaCalcOutput.value,
                      )}
                      key={eligibilityCriteriaCalcOutput.key}
                    />
                  );
                },
              )}
            </SimpleGrid>
          </Box>
        </>
      )}

      {/* concentration limit calcs */}
      {concentrationLimitCalcOutputs.length > 0 && (
        <>
          <Heading as="h3" fontSize="xl" mb="30px">
            Excess concentration
          </Heading>
          <Box mt="25px" mb="25px">
            <SimpleGrid
              columns={{
                sm: 1,
                md: 2,
                lg: 3,
                xl: 4,
              }}
              spacingX={8}
              spacingY={10}
              mb={30}
            >
              {_.map(
                concentrationLimitCalcOutputs,
                (concentrationLimitCalcOutput) => {
                  return (
                    <ConcentrationLimitsDetailCard
                      label={concentrationLimitCalcOutput.label}
                      formattedValue={dollarNumberWithCommas(
                        concentrationLimitCalcOutput.value,
                      )}
                      key={concentrationLimitCalcOutput.key}
                    />
                  );
                },
              )}
            </SimpleGrid>
          </Box>
        </>
      )}
    </Box>
  );
};
